export const MEAL_SCHEDULE = [
    { mealType: 'morning', time: { hour: 8, minute: 0 } },  // 8:00 AM
    { mealType: 'afternoon', time: { hour: 13, minute: 0 } },     // 1:00 PM
    { mealType: 'evening', time: { hour: 17, minute: 0 } },    // 5:00 PM
    { mealType: 'night', time: { hour: 20, minute: 0 } }     // 8:00 PM
  ];


export const FINISHED_MEAL_STATUSES = ["cooked", "completed", "ended"];

export const NOTE_STATUS = {
  COMPLETED: "completed",
  PENDING: "pending"
}